<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <BreadCrumb
          parentRouteName="PointList" 
          :extra-items="[
            '扣除點數'
          ]" 
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-overlay :show="showLoading">
          <b-card>
            <div class="row d-flex mb-4 mb-xl-2 justify-content-between">
              <h4 class="col-12 col-xl-6 mb-2 mb-xl-0 font-weight-bold">
                扣除點數
              </h4>
              <div class="col-12 col-xl-8 mt-3">
                <b-form-group
                  label-cols="12"
                  label-cols-lg="2"
                  label-size="sm"
                  label="通路"
                >
                  <b-form-select
                    v-model="merchantId"
                    :options="merchants"
                  ></b-form-select>
                </b-form-group>

                <b-form-group
                  label-cols="12"
                  label-cols-lg="2"
                  label-size="sm"
                  label="會員 id"
                >
                  <b-form-input
                    class="mb-2 mr-sm-2 mb-sm-0"
                    v-model="customerInfo"
                    disabled
                  ></b-form-input>
                  <PointAddCustomer
                    :customerId="point.customer_id"
                    :merchantId="merchantId"
                    @added="selectedCustomer"
                  ></PointAddCustomer>
                </b-form-group>

                <b-form-group
                  label-cols="12"
                  label-cols-lg="2"
                  label-size="sm"
                  label="分店 id"
                >
                  <b-form-input
                    class="mb-2 mr-sm-2 mb-sm-0"
                    v-model="point.branch_id"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  label-cols="12"
                  label-cols-lg="2"
                  label-size="sm"
                  label="扣除點數"
                >
                  <b-form-input
                    class="mb-2 mr-sm-2 mb-sm-0"
                    v-model="point.point"
                    placeholder="輸入10 (將扣除10點)"
                    type="number"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="!v$.point.point.$error">此欄位為必填且為正整數</b-form-invalid-feedback>
                </b-form-group>

                <b-form-group
                  label-cols="12"
                  label-cols-lg="2"
                  label-size="sm"
                  label="類型"
                >
                  <b-form-input
                    class="mb-2 mr-sm-2 mb-sm-0"
                    value="使用點數"
                    disabled
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  label-cols="12"
                  label-cols-lg="2"
                  label-size="sm"
                  label="說明"
                >
                  <b-form-input
                    class="mb-2 mr-sm-2 mb-sm-0"
                    v-model="point.description"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  label-cols="12"
                  label-cols-lg="2"
                  label-size="sm"
                  label="活動 id"
                >
                  <b-form-input
                    class="mb-2 mr-sm-2 mb-sm-0"
                    v-model="point.event_id"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  label-cols="12"
                  label-cols-lg="2"
                  label-size="sm"
                  label="target type"
                >
                  <b-form-input
                    class="mb-2 mr-sm-2 mb-sm-0"
                    v-model="point.target_type"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  label-cols="12"
                  label-cols-lg="2"
                  label-size="sm"
                  label="target id"
                >
                  <b-form-input
                    class="mb-2 mr-sm-2 mb-sm-0"
                    v-model="point.target_id"
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>
            <div class="d-flex justify-content-center">
              <b-button
                class="mr-3"
                @click="handleCancel"
                variant="outline-danger"
              >
                返回
              </b-button>
              <b-button
                @click="handleSubmit"
                variant="success"
                :disabled="isSubmitting || isFormInvalid"
              >
                儲存
              </b-button>
            </div>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import useVuelidate from "@vuelidate/core";
import { required, integer, minValue } from "@vuelidate/validators";
import pointApi from "@/apis/point";
import merchantApi from "@/apis/merchant";
import PointAddCustomer from "@/pages/Dashboard/Point/PointAddCustomer.vue";
import * as consts from "@/consts";
import BreadCrumb from "@/components/Dashboard/BreadCrumb";

export default {
  components: { PointAddCustomer, BreadCrumb },

  setup: () => ({ v$: useVuelidate() }),
  
  validations() {
    return {
      point: {
        customer_id: { required },
        point: { required, integer, minValue: minValue(1) },
      }
    };
  },

  data() {
    return {
      merchantId: null,
      merchants: [{ value: null, text: "請選擇" }],
      showLoading: false,
      isEditing: true,
      isSubmitting: false,
      validationErrors: null,
      customerInfo: null,
      point: {
        customer_id: null,
        order_id: null,
        branch_id: null,
        point: null,
        memo: null,
        type: 2,
        start_at: null,
        expired_at: null,
        used_point: null,
        event_id: null,
        source_type: null,
        source_id: null,
      },
    };
  },

  computed: {
    ...mapState("general", {
      organization: (state) => state.organization,
      defaultMerchantType: (state) => state.defaultMerchantType,
    }),
    ...mapGetters('route', ['routeQuery']),
    
    /**
     * 檢查表單是否無效
     * @returns {boolean} 當會員id或扣除點數為空時返回true
     */
    isFormInvalid() {
      return !this.point.customer_id || !this.point.point;
    },
  },
  mounted() {
    this.fetchMerchants();
  },
  methods: {
    /**
     * 提交表單,扣除會員點數
     */
    async handleSubmit() {
      // 執行表單驗證
      const result = await this.v$.$validate();
      if (!result) {
        return;
      }

      this.isSubmitting = true;
      try {
        const submitData = {
          ...this.point,
          point: Math.abs(Number(this.point.point)),
        };
        let response = await pointApi.usePoint(this.merchantId, submitData);

        if (response.status && response.status >= 200) {
          this.$swal.fire({
            title: "扣除成功",
            type: "success",
          });

          this.$router.push({name: "PointList", query: this.routeQuery});
        }
      } catch (error) {
        if (error.response.status === 422 && error.response.data.message) {
          this.validationErrors = error.response.data.message;
        } else {
          this.$swal.fire({
            title: "扣除失敗",
            type: "error",
          });
        }
      } finally {
        this.isSubmitting = false;
      }
    },
    selectedCustomer(value) {
      this.customerInfo = `${value.name}`;
      this.point.customer_id = value.id;
      this.$forceUpdate();
    },
    handleCancel() {
      this.$router.push({name: "PointList", query: this.routeQuery});
    },
    async fetchMerchants() {
      const { data } = await merchantApi.list();

      this.merchants = [
        { value: null, text: "請選擇" },
        ...data.data.map((merchant) => {
          return {
            value: merchant.id,
            type: merchant.type,
            text: `${merchant.name} (${merchant.type_name})`,
          };
        }),
      ];

      this.merchantId = this.merchants.find((merchant) => merchant.type === this.defaultMerchantType)?.value ??
        this.merchants.find((merchant) => merchant.type === consts.MERCHANT_TYPES.LINE_TYPE)?.value ;
    },
  },
};
</script>
